/* Umami events that a data-umami-event attribute cannot carry (loaded by snippets/umami.liquid):
   - [data-track-load] markers: rendered only in a success state (lead_submit, newsletter_signup)
     or on the 404 page (not_found), tracked once the page has loaded (after Umami's page view);
   - tel: and mailto: clicks anywhere, page bodies included (names as in vs-web).
   Observing only: no preventDefault, never throws, nothing when Umami is blocked.
   ponytail: a reload of a success page counts again; dedupe when the numbers show it. */
(function () {
  function track(name, data) {
    try {
      if (window.umami && typeof window.umami.track === 'function') window.umami.track(name, data);
    } catch (e) { /* tracking never breaks the page */ }
  }

  window.addEventListener('load', function () {
    var markers = document.querySelectorAll('[data-track-load]');
    for (var i = 0; i < markers.length; i++) {
      track(markers[i].getAttribute('data-track-load'));
    }
  });

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    var href = link ? link.getAttribute('href') : '';
    if (/^\s*tel:/i.test(href)) track('phone_click');
    else if (/^\s*mailto:/i.test(href)) track('email_click');
  }, true);
})();
